// App.js - WEB
import React, { Component } from "react";
import { StyleSheet, Dimensions, Image, TouchableOpacity, View } from "react-native";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { firestore } from "../firebase.js";
import Header from "../header";
import Footer from "../footer";
import "./toggle.css";
// Load Stripe
import { loadStripe } from "@stripe/stripe-js";
import { updateDimensions, styles } from "../styles";

let stripe = null;
const STRIPE_API_URL = "https://us-central1-hey-addy-chatgpt.cloudfunctions.net/stripeUtils/stripe"


class Pricing extends Component {
    constructor(props) {
        super(props);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const uid = urlParams.get("uid") == null ? undefined : urlParams.get("uid");
        const checkout = urlParams.get("checkout") == null ? undefined : urlParams.get("checkout");

        if (checkout) {
            // Stripe redirect immediate to checkout session
            this.loadStripeAndGoToCheckout(checkout);
        }

        this.state = {
            successMessage: "",
            newUpdates: {},
            recurring: "monthly",
            uid: uid,
        };
    }

    updateDimensions() {
        updateDimensions();
        this.setState();
    }

    componentDidMount() {
        this.updateDimensions();
        this.loadStripe();

        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    async loadStripeAndGoToCheckout(sessionId) {
        stripe = await loadStripe(
            "pk_live_51Mn5GDAaf2OpP5o1qHlPYyxfcqKT9z69JQNynq0f3rPvdoOnZNtJYM3BOX9vJniBdvW5SYrNfqAv3vBPyutZsNeU00BYN8d9bL"
        );
        stripe.redirectToCheckout({ sessionId: sessionId });
    }

    async loadStripe() {
        stripe = await loadStripe(
            "pk_live_51Mn5GDAaf2OpP5o1qHlPYyxfcqKT9z69JQNynq0f3rPvdoOnZNtJYM3BOX9vJniBdvW5SYrNfqAv3vBPyutZsNeU00BYN8d9bL"
        );
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillMount() { }

    onSubscribeClick = async (priceID, planID, buttonId) => {
        

        const uid = this.state.uid;
        if (uid && uid != undefined && uid != null) {
            this.stripeCreateCheckoutSession(uid, planID, buttonId);
        } else {
            // No UID redirect to stripe with email
            stripe.redirectToCheckout({
                mode: "subscription",
                successUrl: "https://addy-ai.com/subscribed",
                cancelUrl: "https://addy-ai.com/pricing",
                lineItems: [
                    {
                        price: priceID,
                        quantity: 1,
                    },
                ],
            });
        }

        
    };

    stripeCreateCheckoutSession = async (uid, planId, buttonId) => {

        const subscribeButton = document.getElementById(buttonId);
        if (subscribeButton) {
            subscribeButton.innerHTML = `Subscribe <div class="loader-new"></div>`;
        }

        const checkoutSessionEndpoint = `${STRIPE_API_URL}/checkout-session?uid=${uid}&planID=${planId}`
        const sessionId = await this.fetchResponseDataGet(checkoutSessionEndpoint, "sessionID");

        if (subscribeButton) {
            subscribeButton.innerHTML = `Subscribe`;
        }

        if (!sessionId) {
            alert("Sorry something went wrong. Please try again later");
            return;
        }

        stripe.redirectToCheckout({ sessionId: sessionId });

    };

    renderNewUpdates = (updates) => {
        const version = updates.version;
        const newUpdates = updates.updates || [];

        const renderHTML = [];
        renderHTML.push(<h4 style={{ color: "#2B1C50", marginBottom: "15px" }}>What's new in v{version} &#127873;</h4>);

        for (let i = 0; i < newUpdates.length; i++) {
            renderHTML.push(
                <div className="HorizontalFlex CenterOppositeDirectionToo">
                    <p style={{ fontSize: "22px", margin: "0px", marginRight: "12px" }}>&#9900;</p>
                    <p style={{ fontSize: "22px", margin: "0px" }}>{newUpdates[i]}</p>
                </div>
            );
        }
        return renderHTML;
    };
    openHowTo = () => {
        // Log this click
        window.open("https://addy-ai.com/how-to-upgrade", "_blank");
    };

    contactUsPressed = () => {
        window.open("mailto:michael@addy-ai.com");
    };

    fetchResponseDataGet = async (endpoint, attributeToget) => {
        let returnVal;
        await fetch(endpoint, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    returnVal = data[attributeToget];
                } else {
                    returnVal = undefined;
                }
            }).catch(() => {
                returnVal = undefined;
            });
        return returnVal;
    }

    handleRadioButtonChange = (recurring) => {
        const yearlyButton = document.getElementById("yearly");
        const monthlyButton = document.getElementById("monthly");

        if (recurring == "yearly") {
            monthlyButton.style.background = "rgba(255, 255, 255, 0.1)";
            monthlyButton.style.color = "rgba(255, 255, 255, 1)";

            yearlyButton.style.background = "#735DDD";
            yearlyButton.style.color = "#FFFFFF";
            // Update state
            this.setState({
                recurring: recurring,
            });
        } else {
            // Monthly
            yearlyButton.style.background = "rgba(255, 255, 255, 0.1)";
            yearlyButton.style.color = "rgba(255, 255, 255, 1)";

            monthlyButton.style.background = "#735DDD";
            monthlyButton.style.color = "#FFFFFF";
            this.setState({
                recurring: recurring,
            });
        }
    };

    onAppLogoClick = () => {
        window.location.href = "/";
        // window.open("https://gifttutoring.org/attachments/download/4563/GIFTSym10_Proceedings_Final_052722.pdf", '_blank');
    };

    MainPage() {
        return (
            <div
                div
                className="AboutUsContainer"
                style={{
                    width: "100%",
                    paddingLeft: styles.basic.blueBgPaddingLeft / 2,
                    paddingRight: styles.basic.blueBgPaddingLeft / 2,
                    justifyContent: "center",
                    // marginBottom: 100,
                    paddingTop: 150,
                    backgroundColor: "rgb(32, 33, 36)"
                }}>
                <h1 style={{
                    color: "#FFFFFF"
                }} className="pricing-header">Simple, transparent pricing!</h1>
                {/* <p className="pricing-sub-helper">
                    
                </p> */}
                {/* <p className="subtitle-pricing-text">
                    Our <mark style={{ backgroundColor: "transparent", fontWeight: "bold" }}>FREE</mark> plan gives you 3 email
                    generations per day with <mark style={{ backgroundColor: "transparent", fontWeight: "bold" }}>ALL</mark>{" "}
                    Unlimited features!
                </p> */}

                <br />
                {/* Toggle between monthly and yearly */}
                <div className="toggle-div">
                    <div class="switch">
                        <p id="monthly" onClick={() => this.handleRadioButtonChange("monthly")}>
                            Monthly
                        </p>
                        <p style={{
                            color: "#FFFFFF",
                            backgroundColor: "rgba(255, 255, 255, 0.1)"
                        }} id="yearly" onClick={() => this.handleRadioButtonChange("yearly")}>
                            Annual (20% off)
                        </p>
                    </div>
                </div>

                <br />

                {this.state.recurring == "monthly" && (
                    <div className="pricing-main-div" id="monthly-pricing">
                        <Row style={{ width: "100%", paddingTop: 30 }}>
                            <Col
                                md="4"
                                style={{ display: "flex", flexDirection: "column", alignItems: "center", alignItems: "center" }}>
                                <div class="columns border-box plan-container">
                                    <div className="fake-skeleton-box">
                                        <p className="highlighting-text"></p>
                                    </div>
                                    <p className="plan-title">Free</p>
                                    <p className="plan-type">
                                        No personalization
                                    </p>
                                    <p className="plan-summary">
                                        Three free AI-generated emails per day, powered by GPT 3.5, with limited features.
                                    </p>
                                    <p className="price-amount">
                                        $ 0 <mark class="price-interval">/ month</mark>
                                    </p>
                                    <div
                                        className="subscribe-button"
                                        onClick={() => {
                                            window.open(
                                                "https://chrome.google.com/webstore/detail/addy-ai-chatgpt-email-ass/gldadickgmgciakdljkcpbdepehlilfn",
                                                "_blank"
                                            );
                                        }}>
                                        {this.state.uid ? "Get started" : "Get started"}
                                    </div>
                                    <ul className="price">
                                        <li className="price-feature">&#9989; 3 AI emails per day</li>
                                        <li className="price-feature">&#9989; Powered by GPT 3.5</li>
                                        <li className="price-feature">&#9989; Compose, Reply, and Follow-up emails</li>
                                        {/* <li className="price-feature">&#9989; AI Reply emails</li>
                                        <li className="price-feature">&#9989; AI Follow up emails</li> */}
                                        <li className="price-feature">&#9989; Access over 10 tones</li>
                                        <li className="price-feature">&#9989; Control generated email length</li>
                                        <li className="price-feature">&#9989; Add your own prompts</li>
                                        <li className="price-feature">&#9989; Rewrite any part of the email</li>
                                    </ul>
                                </div>
                            </Col>

                            <Col
                                md="4"
                                style={{ display: "flex", flexDirection: "column", alignItems: "center", alignItems: "center" }}>
                                <div className="columns border-box plan-container best-deal-container">
                                    <div className="skeleton-box">
                                        <p className="highlighting-text">&#129321; Best deal</p>
                                    </div>

                                    <p className="plan-title">Unlimited</p>

                                    <p className="plan-type">
                                        Best for personal, professional, academic email writing.
                                    </p>

                                    <p className="plan-summary">
                                        Unlimited daily emails, much smarter responses, and personalized emails in all major languages!
                                    </p>

                                    <p className="price-amount">
                                        $ 19 <mark className="price-interval">/ month</mark>
                                    </p>

                                    <div
                                        className="subscribe-button"
                                        id="unlimited-monthly-btn"
                                        onClick={() => {
                                            if (this.state.uid) {
                                                this.onSubscribeClick("price_1NoquqAaf2OpP5o1iIgIVKbI", "unlimited-monthly", "unlimited-monthly-btn");
                                            } else {
                                                // No UID
                                                this.openHowTo();
                                            }
                                        }}>
                                        {this.state.uid ? "Subscribe" : "How to subscribe"}
                                    </div>
                                    <ul className="price">
                                        <li className="price-feature">&#9989; Everything in Free</li>
                                        <li className="price-feature">&#9989; Powered by GPT-4</li>
                                        <li className="price-feature">&#9989; Unlimited emails per day</li>
                                        <li className="price-feature">&#9989; Emails personalized to sound like you</li>
                                        <li className="price-feature">&#9989; All major languages</li>
                                        <li className="price-feature">&#9989; Suggested replies</li>
                                        <li className="price-feature">&#9989; Summarize emails & attachments (coming soon)</li>
                                    </ul>
                                </div>
                            </Col>

                            <Col
                                md="4"
                                style={{ display: "flex", flexDirection: "column", alignItems: "center", alignItems: "center" }}>
                                <div className="columns border-box plan-container">
                                    <div className="fake-skeleton-box">
                                        <p className="highlighting-text"></p>
                                    </div>
                                    <p className="plan-title">Business</p>
                                    <p className="plan-type">
                                        Best for professional teams in the same company.
                                    </p>
                                    <p className="plan-summary">
                                        We will train a custom AI that understands your business type, culture, and brand voice! &nbsp; &nbsp;
                                        &nbsp; &nbsp;
                                    </p>
                                    <p className="price-amount">
                                        &nbsp;
                                    </p>
                                    <div className="subscribe-button" onClick={() => this.contactUsPressed()}>
                                        Contact Us
                                    </div>
                                    <ul className="price">
                                        <li className="price-feature">&#9989; Everything in Unlimited</li>
                                        <li className="price-feature">&#9989; Fine-tuned GPT-4 and custom models for your business</li>
                                        <li className="price-feature">&#9989; Unlimited emails per day</li>
                                        <li className="price-feature">&#9989; Train AI to understand your brand voice</li>
                                        <li className="price-feature">&#9989; Background-generated emails</li>
                                        <li className="price-feature">&#9989; Shared knowledge base with your team</li>
                                        <li className="price-feature">&#9989; Early access to new features</li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}

                {this.state.recurring == "yearly" && (
                    <div className="pricing-main-div" id="yearly-pricing">
                        <Row style={{ width: "100%", paddingTop: 30 }}>
                            <Col
                                md="4"
                                style={{ display: "flex", flexDirection: "column", alignItems: "center", alignItems: "center" }}>
                                <div class="columns border-box plan-container">
                                    <div className="fake-skeleton-box">
                                        <p className="highlighting-text"></p>
                                    </div>
                                    <p className="plan-title">Free</p>
                                    <p className="plan-type">
                                        No personalization
                                    </p>
                                    <p className="plan-summary">
                                        Three free AI-generated emails per day, powered by GPT 3.5, with limited features.
                                    </p>
                                    <p className="price-amount-off">$ 0</p>
                                    <p className="price-amount">
                                        $ 0 <mark class="price-interval">/ year</mark>
                                    </p>
                                    <div
                                        className="subscribe-button"
                                        onClick={() => {
                                            window.open(
                                                "https://chrome.google.com/webstore/detail/addy-ai-chatgpt-email-ass/gldadickgmgciakdljkcpbdepehlilfn",
                                                "_blank"
                                            );
                                        }}>
                                        {this.state.uid ? "Get started" : "Get started"}
                                    </div>
                                    <ul className="price">
                                        <li className="price-feature">&#9989; 3 AI emails per day</li>
                                        <li className="price-feature">&#9989; Powered by GPT 3.5</li>
                                        <li className="price-feature">&#9989; Compose, Reply, and Follow-up emails</li>
                                        {/* <li className="price-feature">&#9989; AI Reply emails</li>
                                        <li className="price-feature">&#9989; AI Follow up emails</li> */}
                                        <li className="price-feature">&#9989; Access over 10 tones</li>
                                        <li className="price-feature">&#9989; Control generated email length</li>
                                        <li className="price-feature">&#9989; Add your own prompts</li>
                                        <li className="price-feature">&#9989; Rewrite any part of the email</li>
                                    </ul>
                                </div>
                            </Col>

                            <Col
                                md="4"
                                style={{ display: "flex", flexDirection: "column", alignItems: "center", alignItems: "center" }}>
                                <div className="columns border-box plan-container best-deal-container">
                                    <div className="skeleton-box">
                                        <p className="highlighting-text">&#129321; Best deal</p>
                                    </div>

                                    <p className="plan-title">Unlimited</p>
                                    <p className="plan-type">
                                        Best for personal, professional, academic email writing.
                                    </p>
                                    <p className="plan-summary">
                                        Unlimited daily emails, much smarter responses, and personalized emails in all major languages!
                                    </p>
                                    <p className="price-amount-off">$ 228</p>
                                    <p className="price-amount">
                                        $ 182 <mark className="price-interval">/ year</mark>
                                    </p>

                                    <div
                                        className="subscribe-button"
                                        id="unlimited-annual-btn"
                                        onClick={() => {
                                            if (this.state.uid) {
                                                this.onSubscribeClick("price_1NoqxKAaf2OpP5o14yDFMmTN", "unlimited-annual", "unlimited-annual-btn");
                                            } else {
                                                // No UID
                                                this.openHowTo();
                                            }
                                        }}>
                                        {this.state.uid ? "Subscribe" : "How to subscribe"}
                                    </div>
                                    <ul className="price">
                                        <li className="price-feature">&#9989; Everything in Free</li>
                                        <li className="price-feature">&#9989; Powered by GPT-4</li>
                                        <li className="price-feature">&#9989; Unlimited emails per day</li>
                                        <li className="price-feature">&#9989; Emails personalized to sound like you</li>
                                        <li className="price-feature">&#9989; All major languages</li>
                                        <li className="price-feature">&#9989; Suggested replies</li>
                                        <li className="price-feature">&#9989; Summarize emails & attachments (coming soon)</li>
                                    </ul>
                                </div>
                            </Col>

                            <Col
                                md="4"
                                style={{ display: "flex", flexDirection: "column", alignItems: "center", alignItems: "center" }}>
                                <div className="columns border-box plan-container">
                                    <div className="fake-skeleton-box">
                                        <p className="highlighting-text"></p>
                                    </div>
                                    <p className="plan-title">Business</p>
                                    <p className="plan-type">
                                        Best for professional teams in the same company.
                                    </p>
                                    <p className="plan-summary">
                                        We will train a custom AI that understands your business type, culture, and brand voice! &nbsp; &nbsp;
                                        &nbsp; &nbsp;
                                    </p>
                                    <p className="price-amount-off">&nbsp;</p>
                                    <p className="price-amount">
                                        &nbsp;
                                    </p>
                                    <div className="subscribe-button" onClick={() => this.contactUsPressed()}>
                                        Contact Us
                                    </div>
                                    <ul className="price">
                                        <li className="price-feature">&#9989; Everything in Unlimited</li>
                                        <li className="price-feature">&#9989; Fine-tuned GPT-4 and custom models for your business</li>
                                        <li className="price-feature">&#9989; Unlimited emails per day</li>
                                        <li className="price-feature">&#9989; Train AI to understand your brand voice</li>
                                        <li className="price-feature">&#9989; Background-generated emails</li>
                                        <li className="price-feature">&#9989; Shared knowledge base with your team</li>
                                        <li className="price-feature">&#9989; Early access to new features</li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        );
    }

    render() {
        return (
            <div style={{ height: "100vh" }}>
                <div
                    id="addy-main-header"
                    className="HeaderContainer"
                    style={{
                        height: 81,
                        width: "100%",
                        paddingLeft: styles.basic.headerHorizontalPadding,
                        top: 0,
                        shadowColor: "#000000",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        paddingRight: styles.basic.headerHorizontalPadding,
                        alignItems: "center",
                        backgroundColor: "rgb(32, 33, 36)"

                    }}>
                    <div className="AppLogo" onClick={this.onAppLogoClick}>
                        <Image
                            style={{ width: 26, height: 26, marginRight: 12 }}
                            source={require("../img/logo.png")}
                            resizeMode="contain"
                        />
                        <p className="AppTitleText" style={{
                            color: "white",
                        }}>Addy AI</p>
                    </div>

                    <div className="HeaderOptionsDiv" style={{
                        display: "flex", flexDirection: "column",
                        position: "absolute",
                        top: 7,
                        right: 6,
                        // paddingRight: 20,  
                        alignItems: "flex-end"
                    }}>

                        <nav class="navbar navbar-expand-lg navbar-light">

                            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon navbar-toggler-icon-addy-dark"></span>
                            </button>
                            <div class="collapse navbar-collapse" id="navbarNavDropdown" style={{
                                // width: "180px",
                                padding: "10px",
                                marginTop: styles.basic.navMarginTop,
                                boxShadow: styles.basic.navBoxShadow,
                                backgroundColor: "rgb(32, 33, 36)",
                                borderRadius: "20px"
                            }}>
                                <ul class="navbar-nav" style={{
                                    width: "fit-content",
                                }}>

                                    {/* <li class="nav-item">
                                    <a id="addy-nav-link" class="nav-link active" href="#">Pricing</a>
                                </li> */}

                                    {/* <li class="nav-item">
                                            <TouchableOpacity style={{
                                                marginRight: "15px"
                                            }} className="SubmitButton" onPress={() => {
                                                window.open(
                                                    "https://calendly.com/michael-addy-ai/addy-ai-demo",
                                                    "_blank"
                                                );
                                            }}>
                                                <p className="SubmitTextHeader" style={{
                                                    backgroundColor: "#8AB4F8",
                                                    color: "black",
                                                    borderRadius: "30px"
                                                }}>Download</p>
                                            </TouchableOpacity>
                                        </li> */}

                                    <li class="nav-item">
                                        <a style={{
                                            color: "#ffffff"
                                        }} id="addy-nav-link" target="_blank" class="nav-link active" href="/about-us">About Us</a>
                                    </li>

                                    <li class="nav-item">
                                        <a style={{
                                            color: "#ffffff"
                                        }} id="addy-nav-link" target="_blank" class="nav-link active" href="https://addy.beehiiv.com">Blog</a>
                                    </li>

                                    <li class="nav-item">
                                        <a style={{
                                            color: "#ffffff"
                                        }} id="addy-nav-link" target="_blank" class="nav-link active" href="https://addy-ai.com/pricing">Pricing</a>
                                    </li>
                                    {/* <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle active" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Channels
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a id="addy-nav-link" class="dropdown-item" href="#">Email</a>
                                        <a id="addy-nav-link" class="dropdown-item" href="#">Live Chat</a>
                                    </div>
                                </li> */}
                                </ul>
                            </div>
                        </nav>

                        {/* <p onClick={() => this.gotToLocalHref("/pricing")} className="HeaderOptionButton">Pricing</p> */}
                    </div>
                </div>


                {this.MainPage()}
                <Footer backgroundColor="#3c4043" textColor="#FFFFFF" iconColor="#FFFFFF" />
            </div>
        );
    }
}

export default Pricing;
